import { gql } from "@apollo/client";

export const BUILDING_MAP_FIELDS_FRAGMENT = gql`
  fragment BuildingMapFieldsV2 on BuildingInterface {
    id
    slug
    geocode {
      id
      latitude
      longitude
      formattedAddress
    }
  }
`;

export default BUILDING_MAP_FIELDS_FRAGMENT;
